module.exports = __webpack_public_path__ + "img/aiNose-B03.df3b5e6b.jpg";